import React from 'react';
import {abvNum, getPct} from './CommonJS';
import {AnimateNumber} from './UIAnimateToggleDiv';
import {tailCheck} from './CommonReact';

export function UIStackedBar({
	vals, valDisp, colors, textColors, classes, maxVals, onClick, titles, onTitle
}) {
	const total = vals.reduce((a, b) => a + (b ?? 0), 0);

	return (
		<span className='inline-flex w-full'>
			<span className='inline-flex align-middle relative whitespace-nowrap items-center h-3' style={{width: getPct(total, maxVals || total)}}>
				{vals.map((val, i) => {
					if (!val) return null;
					const valLoc = val.toLocaleString();
					return (
						<span
							key={i} className={`text-center ${onClick && 'cursor-pointer'} ${classes?.[i]}`}
							{...onClick && {onClick: e => onClick({e, val, i})}}
							style={{
								flex: '0 1 ' + getPct(val, total),
								backgroundColor: colors?.[i],
								color: textColors?.[i]
							}}
							{...(titles ? {title: `${valLoc} ${titles[i]}`} :
								onTitle ? {title: onTitle({val, valLoc, i})} : {})}>
							{!valDisp ? abvNum(val) :
								Array.isArray(valDisp) ? valDisp[i] : valDisp({val, valLoc, i})}
						</span>
					);
				})}
			</span>
		</span>
	);
}

export function UIProgressBar({
	val, total, className = '', pctTitle = '', classNameBar = '', showTotals = false, ...props
}) {
	const number = AnimateNumber({target: (val / total * 1000 | 0) / 10, animDur: 1400});

	return (
		<div
			className={tailCheck(className, 'flex', 'w-full', 'relative', 'h-5', 'whitespace-nowrap', 'shadow', 'border', 'min-h-0 shrink-0', 'overflow-hidden')}
			{...props}>
			<div className={`${classNameBar || (total < val ? 'bg-sec': 'bg-prm-main')}`} style={{flex: '0 1 ' + number+'%'}}/>
			{showTotals && <span className='absolute inset-0 flex items-center justify-center text-2xs'>
				<span>{abvNum(val)} / {abvNum(total)} {pctTitle}</span>
			</span>}
		</div>
	);
}
